/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import SafeLink from "components/commons/SafeLink";
import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

const downloadAppQr = `${WealthyEnv.CDN_URL}/articles/client-app-qr.svg`;
const wealthyLogo = `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`;
const playStoreButton = `${WealthyEnv.CDN_URL}/phoenix/play-store-button.png`;
const appStoreButton = `${WealthyEnv.CDN_URL}/articles/app-store-icon.svg`;

const AppDownload = () => {
  return (
    <AppDownloadWrapper>
      <LogoWrapper>
        <WealthyLogo
          alt="wealthy-logo"
          src={wealthyLogo}
        />
      </LogoWrapper>
      <Tagline>
        <span>Download the Wealthy App</span>
        to enjoy efficient Trading and Investing!
      </Tagline>
      <QrCodeImage
        alt="Download App QR Code"
        src={downloadAppQr}
      />
      <AppLinks>
        <AppLinkItem href={WealthyEnv.APP_STORE_DOWNLOAD_LINK}>
          <LinkImage
            alt="google-play"
            src={appStoreButton}
          />
        </AppLinkItem>
        <AppLinkItem href={WealthyEnv.PLAY_STORE_DOWNLOAD_LINK}>
          <LinkImage
            alt="app-store"
            src={playStoreButton}
          />
        </AppLinkItem>
      </AppLinks>
    </AppDownloadWrapper>
  );
};

const AppDownloadWrapper = styled.div`
  width: 100%;
  background-color: ${colors.cultured};
  text-align: center;
  padding: 4rem;
  padding-top: 3rem;
`;

const LogoWrapper = styled.div`
  text-align: left;
`;

const WealthyLogo = styled.img`
  height: 25px;
`;

const Tagline = styled.h2`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 1.6;
  padding-top: 4rem;

  span {
    font-size: 1.8rem;
    font-weight: 600;
    display: block;
  }
`;

const QrCodeImage = styled.img`
  width: 145px;
  margin: 4rem 0;
`;

const AppLinks = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const AppLinkItem = styled(SafeLink)`
  display: inline-block;

  &:not(:last-child) {
    margin-right: 20px;
    @media (max-width: 576px) {
      margin-right: 20px;
    }
  }
`;

const LinkImage = styled.img`
  height: 38px;

  @media (max-width: 576px) {
    height: 30px;
  }
`;

export default AppDownload;
